var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_5705)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.75 37.375C5.75 35.7848 7.03477 34.5 8.625 34.5H23H31.625H37.375V40.25H31.625H23H8.625C7.03477 40.25 5.75 38.9652 5.75 37.375Z",
    fill: "url(#paint0_linear_217_5705)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 0C3.86328 0 0 3.86328 0 8.625V37.375C0 42.1367 3.86328 46 8.625 46H34.5H37.375C38.9652 46 40.25 44.7152 40.25 43.125C40.25 41.5348 38.9652 40.25 37.375 40.25H31.625H23H8.625C7.03477 40.25 5.75 38.9652 5.75 37.375C5.75 35.7848 7.03477 34.5 8.625 34.5H23H31.625H37.375C38.9652 34.5 40.25 33.2152 40.25 31.625V2.875C40.25 1.28477 38.9652 0 37.375 0H34.5H8.625ZM18.6875 10.0625C18.6875 9.27188 19.3344 8.625 20.125 8.625H23C23.7906 8.625 24.4375 9.27188 24.4375 10.0625V14.375H28.75C29.5406 14.375 30.1875 15.0219 30.1875 15.8125V18.6875C30.1875 19.4781 29.5406 20.125 28.75 20.125H24.4375V24.4375C24.4375 25.2281 23.7906 25.875 23 25.875H20.125C19.3344 25.875 18.6875 25.2281 18.6875 24.4375V20.125H14.375C13.5844 20.125 12.9375 19.4781 12.9375 18.6875V15.8125C12.9375 15.0219 13.5844 14.375 14.375 14.375H18.6875V10.0625Z",
    fill: "url(#paint1_linear_217_5705)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_5705",
    x1: 21.5625,
    y1: 34.5,
    x2: 21.5625,
    y2: 40.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_217_5705",
    x1: 20.125,
    y1: 0,
    x2: 20.125,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F7CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8258F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_5705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.25,
    height: 46,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.d48c0fd2ee6be014c39ed02a2f479b2d.svg";
export { ForwardRef as ReactComponent };